import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { isEmpty } from '../../../../../../helpers/String';

import './style/page-title.css';

export default function PageTitle({ title, description }) {
  useEffect(() => {
    if (!isEmpty(title)) {
      global.document.title = title.concat(
        ' | ',
        `${process.env.REACT_APP_NAME} ${process.env.REACT_APP_REGION}`
      );
    }
  }, [title]);

  return (
    <>
      {(title || description) && (
        <Row>
          <Col md="12" className="page-title">
            {title && <h1>{title}</h1>}
            {description && <p>{description}</p>}
          </Col>
        </Row>
      )}
    </>
  );
}

PageTitle.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

PageTitle.defaultProps = {
  title: null,
  description: null,
};
